module.exports = __webpack_public_path__ + "media/images/emblems/Luins-coat_of_arms-1f19da8080a883e538ae3c016e03184e.svg";